import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateEstablishmentCompanyBranchSchema = z.object({
  bank_account_information: z.object({
    account: z.string({ message: 'Campo Conta é obrigatório' }).trim().min(1, 'Campo Conta é obrigatório'),
    agency: z.string({ message: 'Campo Agência é obrigatório' }).trim().min(1, 'Campo Agência é obrigatório'),
    bank_institution: optionSchema,
    payee_name: z.string({ message: 'Campo Favorecido é obrigatório' }).trim().min(1, 'Campo Favorecido é obrigatório'),
    payee_cnpj: z.string().trim().optional().nullable(),
  }),
})

export type UpdateEstablishmentCompanyBranchValidationSchema = z.infer<typeof updateEstablishmentCompanyBranchSchema>
